import {App, Card, Collapse, Flex, List, Spin} from "antd";
import {FC, useState} from "react";
import styles from './ApproversCard.module.css';
import {groupByRegions} from "../../../../utils/groupByRegions.ts";
import {ApproverStatus} from "../ApproverStatus/ApproverStatus.tsx";
import {EnterOutlined} from "@ant-design/icons";
import {ApproverUser} from "../ApproverUser/ApproverUser.tsx";
import {EventApprover} from "../../../../types/domain.ts";
import {eventsEventIdApprovePost} from "../../../../api/events/eventsEventIdApprovePost.ts";
import {useUsers} from "../../../../queries/useUsers.ts";
import {isFirManager} from "../../../../utils/userTypeGuards.ts";
import {AddApproversPopover} from "../AddApproversPopover/AddApproversPopover.tsx";

type Props = {
    eventId: string;
    approvers: EventApprover[] | undefined;
    approvable: boolean;
    onUpdate: VoidFunction;
    editable: boolean;
}

export const ApproversCard: FC<Props> = ({ eventId, approvers, approvable, onUpdate, editable }) => {
    const { message } = App.useApp();
    const { data: users } = useUsers();
    const staff = users?.filter(({ role }) => role === 'staff');

    const [approveLoading, setApproveLoading] = useState(false);
    const handleApprove = () => {
        setApproveLoading(true);
        eventsEventIdApprovePost(eventId).then(() => {
            void message.success('Согласовано');
            void onUpdate();
        }).catch((e) => {
            console.error(e);
            void message.error(`Ошибка (${JSON.stringify(e)})`);
        }).finally(() => setApproveLoading(false));
    }

    if(!approvers) {
        return (
            <Card className={styles.container}>
                <Flex justify="center">
                    <Spin />
                </Flex>
            </Card>
        )
    }

    const grouppedApprovers = approvers ?
        Object.entries(groupByRegions(approvers))
            .filter(([_, users]) =>
                users.length > 1 ||
                !users[0].user ||
                !isFirManager(users[0].user)
            )
        : [];
    const items = grouppedApprovers.map(([regionName, regionApprovers]) => ({
        key: regionName,
        label: regionName,
        children: (
            <List
                dataSource={regionApprovers}
                renderItem={(approver) => (
                    <List.Item>
                        <Flex align="center" justify="space-between" className={styles.approverRowInner}>
                            <Flex gap={16}>
                                {approver.reason === 'forward' && (
                                    <EnterOutlined className={styles.forwardIcon}/>
                                )}
                                {!approver.user ? (
                                    <Flex vertical gap={16}>
                                        {staff?.map((user) => <ApproverUser key={user.id} user={user} />)}
                                    </Flex>
                                ): (
                                    <ApproverUser user={approver.user} />
                                )}
                            </Flex>
                            <ApproverStatus
                                eventId={eventId}
                                approver={approver}
                                approvers={approvers}
                                approvable={approvable}
                                approveLoading={approveLoading}
                                onApprove={handleApprove}
                            />
                        </Flex>
                    </List.Item>
                )}
            />
        )
    }));

    return (
        <Card
            className={styles.container}
            classNames={{ body: styles.containerBody }}
        >
            {editable && <AddApproversPopover approvers={approvers} eventId={eventId} onUpdate={onUpdate} />}
            <Collapse
                items={items}
                activeKey={items.map(({ key }) => key)}
                expandIcon={() => null}
            />
        </Card>
    )
}